<template>
  <div>
    <div class="product_banner_box">
      <div id="bigBox">
        <section class="product_banner_content">
          <img src="../assets/img/productIcon.png" alt="" />
          <h1>小智</h1>
          <h3>不管在哪！小智都能帮你一键搞定，轻松干活</h3>
          <ul>
            <li
              v-for="(item, index) in downLoadList"
              :key="index"
              @click="downLoad(item.id)"
            >
              <img :src="item.iconUrl" alt="" />
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </section>
      </div>
      <div class="product_page_nav" :class="{ fixed: isNavFixed }">
        <ul id="bigBox" class="product_nav">
          <li
            v-for="(item, index) in navItems"
            :key="index"
            :class="{ li_active: activeNav === index }"
            @click="scrollToSection(index)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <div id="bigBox">
      <!-- 功能优势 -->
      <section class="fun_box module_box" id="fun_box">
        <h1 class="main_title">企业核心服务架构</h1>
        <h3 class="product_sub_title">从下载到开始干活，几分钟即可上手</h3>
        <ul class="fun_ul">
          <li v-for="(item, index) in 4" :key="index">
            <img src="../assets/img/product_icon1.png" alt="" />
            <h2>自动部署，打开即用</h2>
            <p>支持Mac &Windows，内置国产优质大模型，支持切换自定义模型</p>
            <button>开箱直用</button>
          </li>
        </ul>
      </section>
      <!-- 快速上手 -->
      <section class="quick_box module_box" id="quick_box">
        <h1 class="main_title">快速上手</h1>
        <h3 class="product_sub_title">从下载到开始干活，几分钟即可上手</h3>
        <ul class="quick_ul">
          <li>
            <img src="../assets/img/product_icon2.png" alt="" />
            <h3>下载安装</h3>
            <p>支持Mac &Windows一键安装，无需配置环境</p>
          </li>
          <img src="../assets/img/product_jiantou.png" alt="" />
          <li>
            <img src="../assets/img/product_icon3.png" alt="" />
            <h3>扫码绑定微信</h3>
            <p>打开 RX-润信 扫码关联微信 立即关联</p>
          </li>
          <img src="../assets/img/product_jiantou.png" alt="" />
          <li>
            <img src="../assets/img/product_icon4.png" alt="" />
            <h3>微信或电脑发指令，开干</h3>
            <p>通过微信或电脑发消息QClaw立刻帮你执行任务</p>
          </li>
        </ul>
      </section>
      <!-- 使用场景 -->
      <section class="use_box module_box" id="use_box">
        <h1 class="main_title">使用场景</h1>
        <h3 class="product_sub_title">真实场景，既可体验</h3>
        <ul class="use_ul">
          <li v-for="(item, index) in 5" :key="index">
            <div class="msg_right">
              <div>
                <img src="../assets/img/wxIcon.png" alt="" />
                <h5>微信</h5>
                <p>帮我设置每天早上8点推送天气</p>
              </div>
            </div>
            <ul class="msg_left">
              <li>
                <img src="../assets/img/duiIcon.png" alt="" />
                <p>帮我设置每天早上8点推送天气</p>
              </li>
              <li>
                <img src="../assets/img/sunIcon.png" alt="" />
                <p>明天晴，23°C，建议穿薄外套</p>
              </li>
              <li>
                <img src="../assets/img/cloudIcon.png" alt="" />
                <p>后天有雨，记得带伞哦</p>
              </li>
            </ul>
            <div class="li_btm">
              <div>
                <img src="../assets/img/lingIcon.png" alt="" />
                <p>智能提醒</p>
              </div>
              <h3>每日天气定时提醒</h3>
              <p>自动推送天气状况，给出穿衣&出行建议</p>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import { queryProductApi } from "@/apis/index.js";

export default {
  name: "Product",
  components: {},
  data() {
    return {
      isNavFixed: false,
      activeNav: 0,
      navItems: [
        { name: "功能优势", id: "fun_box" },
        { name: "快速上手", id: "quick_box" },
        { name: "使用场景", id: "use_box" },
      ],
      downLoadList: [
        // { name: "macOS (Apple芯片)", id: 1, iconUrl: "" },
        // { name: "macOS (Intel 芯片)", id: 2, iconUrl: "" },
        { name: "Windows", id: 3, iconUrl: "" },
      ],
      bannerHeight: 667, // 横幅高度
      isTopNavVisible: true, // 顶部导航栏是否可见
    };
  },
  created() {},
  mounted() {
    // 添加滚动事件监听

    window.addEventListener("scroll", this.handleScroll);
    this.downLoadList = this.downLoadList.map((item) => {
      if (item.id == 1 || item.id == 2) {
        item.iconUrl = this.$utils.formatImgUrl("homeBarrageImg/macIcon.png");
      } else {
        item.iconUrl = this.$utils.formatImgUrl("homeBarrageImg/winIcon.png");
      }
      return item;
    });
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async downLoad() {
      if (!localStorage.getItem("userInfo")) {
        this.$alert("未登录状态下不可下载", "请登录", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          callback: (action) => {
            if (action == "confirm") {
              this.$router.push({ path: "/login" });
            }
          },
        });
        return;
      }
      if (
        JSON.parse(localStorage.getItem("userInfo")).email == "" ||
        JSON.parse(localStorage.getItem("userInfo")).email == null
      ) {
        this.$alert("点击头像完善信息后下载产品", "请完善信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        });
        console.log();
        return;
      }
      let data = await queryProductApi({ productName: "xiaozhi-win-setup" });
      if (data.code == 200) {
        this.downloadProduct(data.result.resourcePath);
        console.log(data.result.resourcePath);
      } else {
        this.$utils.showMsg("error", data.message);
      }
    },
    // 滚动到对应模块
    scrollToSection(index) {
      const sectionId = this.navItems[index].id;
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
      // 更新激活状态
      this.activeNav = index;
    },
    // 下载产品
    downloadProduct(name) {
      try {
        // 创建一个新的窗口或标签页来触发下载
        // 这样浏览器会在右上角显示下载进度
        const downloadUrl = this.$baseUrl + "api/sys/common/download2/" + name;

        // 创建一个带有 token 的临时链接
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "xiaozhi-win-setup.exe";
        link.target = "_self"; // 使用当前窗口，这样浏览器会处理下载

        // 添加 token 到链接（如果需要）
        const token = localStorage.getItem("token");
        if (token) {
          // 可以考虑将 token 作为查询参数添加
          link.href += `?token=${encodeURIComponent(token)}`;
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error("下载失败", err);
      }
    },
    // 处理滚动事件
    handleScroll() {
      const scrollTop = window.scrollY;

      // 当滚动超过横幅高度时，导航栏固定在顶部
      if (scrollTop > this.bannerHeight - 84) {
        this.isNavFixed = true;
        this.isTopNavVisible = false;
        // 隐藏顶部导航栏
        const topNav = document.querySelector(".my_nav");
        if (topNav) {
          topNav.style.transition = "all 0.5s ease";
          topNav.style.transform = "translateY(-100%)";
        }
      } else {
        this.isNavFixed = false;
        this.isTopNavVisible = true;
        // 显示顶部导航栏
        const topNav = document.querySelector(".my_nav");
        if (topNav) {
          topNav.style.transition = "all 0.5s ease";
          topNav.style.transform = "translateY(0)";
        }
      }

      // 检测当前滚动位置，更新导航激活状态
      this.navItems.forEach((item, index) => {
        const section = document.getElementById(item.id);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            this.activeNav = index;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.product_banner_box {
  width: 100%;
  height: 767px;
  background: url("../assets/img/productBannerImg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.product_banner_content {
  width: 100%;
  height: 767px;
  display: flex;
  flex-direction: column;
  align-items: center;

  > img {
    width: 103px;
    margin: 190px 0 0 0;
  }
  > h1 {
    background: linear-gradient(90deg, #ffffff 40%, #409eff 100%);
    -webkit-background-clip: text;
    color: transparent;
    font-size: 2.25rem;
    font-weight: 600;
    margin: 30px 0;
  }
  > h3 {
    font-size: 1.25rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
  ul {
    width: 875px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    > li {
      width: 292px;
      height: 60px;
      border-radius: 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 160px 40px 0 0;
      > img {
        width: 29px;
        height: 29px;
        margin-right: 20px;
      }
      > p {
        font-size: 1.25rem;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
    }
    > li:last-of-type {
      width: 240px;
      margin-right: 0;
      > img {
        width: 26px;
        height: 31px;
      }
    }
  }
  > button {
    width: 220px;
    height: 60px;
    border-radius: 24px;
    background: linear-gradient(
      90deg,
      rgba(0, 158, 250, 1) 0%,
      rgba(0, 235, 189, 1) 100%
    );
    /** 文本1 */
    font-size: 1.375rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-top: 60px;
  }
}
.product_page_nav {
  width: 100%;
  height: 60px;
  background: rgba(22, 29, 46, 0.5);
  position: absolute;
  bottom: 0;
  transition: all 0.3s ease;
  z-index: 100;

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    bottom: auto;
  }

  .product_nav {
    width: 100%;
    height: 84px;
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;

    > li {
      width: 141px;
      height: 60px;
      line-height: 60px;
      font-size: 1.125rem;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      transition: all 0.3s ease;
      opacity: 1;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
    > .li_active {
      background: linear-gradient(
        90deg,
        rgba(0, 218, 203, 1) 0%,
        rgba(0, 170, 240, 1) 100%
      );
    }
  }
}
.product_sub_title {
  /** 文本1 */
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin: 20px auto;
}
.fun_box,
.quick_box,
.use_box {
  width: 100%;
  padding: 0 8%;
  box-sizing: border-box;
}
.fun_ul,
.quick_ul,
.use_ul {
  margin-top: 40px;
}
.fun_ul {
  width: 100%;
  padding: 0.625rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > li {
    width: 23%;
    height: 234px;
    border-radius: 20px;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.25);
    padding: 1.25rem;
    box-sizing: border-box;
    text-align: left;

    > img {
      width: 45px;
      height: 52px;
    }
    > h2 {
      font-size: 1.25rem;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      margin: 12px 0 10px;
      letter-spacing: 1px;
    }
    > p {
      font-size: 0.875rem;
      font-weight: 400;
      color: rgba(71, 71, 71, 1);
      letter-spacing: 0.5px;
    }
    > button {
      width: 50px;
      height: 20px;
      font-size: 0.625rem;
      font-weight: 400;
      color: #c70000;
      border: 1px solid #c70000;
      border-radius: 4px;
      background: #fff;
      margin-top: 30px;
    }
  }
}

.quick_ul {
  width: 100%;
  height: 290px;
  padding: 0.625rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > img {
    width: 50px;
  }
  > li {
    width: 314px;
    height: 290px;
    opacity: 1;
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 0.625rem 0;

    > img {
      width: 90px;
    }
    > h3 {
      font-size: 1.25rem;
      font-weight: 700;
      color: rgba(0, 0, 0, 1);
    }
    > p {
      width: 200px;
      /** 文本1 */
      font-size: 1rem;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 26px;
      letter-spacing: 1px;
    }
  }
}

.use_ul {
  width: 100%;
  padding: 0.625rem;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > li {
    width: 48%;
    height: 466px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.25);
    margin-bottom: 40px;
    padding: 2.25rem;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;

    .msg_right {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      > div {
        display: flex;
        align-items: center;
        width: 334px;
        height: 57px;
        border-radius: 20px;
        background: rgba(0, 175, 236, 0.2);
        border: 1px solid rgba(4, 133, 176, 1);
        > img {
          width: 24px;
          height: 24px;
          margin: 0 6px 0 20px;
        }
        > h5 {
          font-size: 1.25rem;
          font-weight: 400;
          color: rgba(40, 196, 69, 1);
        }
        > p {
          font-size: 1rem;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          margin-left: 6px;
        }
      }
    }

    .msg_left {
      width: 300px;
      height: 149px;
      border-radius: 20px;
      background: rgba(255, 228, 209, 1);
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      padding: 1.25rem;
      box-sizing: border-box;
      margin-top: 50px;

      > li {
        display: flex;

        > img {
          width: 22px;
          height: 22px;
        }
        > p {
          font-size: 1rem;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          margin-left: 10px;
        }
      }
    }

    .li_btm {
      width: 100%;
      height: 139px;
      background: rgba(230, 230, 230, 1);
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 1.125rem 2.25rem;
      box-sizing: border-box;
      text-align: left;

      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 87px;
        height: 27px;
        background: #eec6c6;
        border-radius: 10px;

        > img {
          width: 16px;
          height: 16px;
        }
        > p {
          font-size: 0.875rem;
          font-weight: 400;
          color: rgba(255, 99, 99, 1);
        }
      }

      > h3 {
        /** 文本1 */
        font-size: 1.5rem;
        font-weight: 700;
        color: rgba(0, 0, 0, 1);
        margin: 16px 0 6px;
      }

      > p {
        font-size: 1.125rem;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
      }
    }
  }
}
</style>
